module.exports = __webpack_public_path__ + "static/media/myBudget.ad45d509.jpg";